// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"269":"72141d45","673":"2e55ff30"}[chunkId] + ".chunk.css";
};